var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.dialogVisible,
        width: "600px",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableData,
            border: "",
            "show-header": false,
            "cell-style": _vm.handleCellStyle,
          },
        },
        [
          _c("el-table-column", { attrs: { prop: "name", align: "center" } }),
          _c("el-table-column", {
            attrs: { prop: "value", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.prop.includes("Price")
                      ? _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$number2money(scope.row.value)) +
                              " "
                          ),
                        ])
                      : _c("span", [_vm._v(_vm._s(scope.row.value))]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }